var React = require('react');

function Paper (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.857 17.714V8.571L14.286 4H7.429a2.286 2.286 0 00-2.286 2.286v11.428A2.286 2.286 0 007.429 20h9.142a2.285 2.285 0 002.286-2.286z"}));
}

Paper.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Paper;

Paper.default = Paper;
